module.exports = "/undefined/BFD-logo.png?d1dd5a39933a683dad08c0ca912a1e7a";